<template>
  <ItemsLister v-bind="itemsListerConfig" :itemsListHelpers="playersListHelpers" />
</template>

<script lang="ts" setup>
import ItemsLister from '@/components/ListingPages/ItemsLister/ItemsLister.vue';
import itemsListerConfig from './config/itemsLister.config';
import usePlayersListHelpers from './playersListHelpers';
const playersListHelpers = usePlayersListHelpers();
</script>

<style lang="scss" scoped>
</style>